(function () {
    'use strict';

    angular.module('vhols-destination-navbar', [])

        .directive('navBar', ['$window', function ($window) {
            return {
                restrict: 'E',
                scope: {
                    overview: '@',
                    hotels: '@',
                    offers: '@',
                    tours: '@',
                    multicentres: '@',
                    thingsToSee: '@',
                    destinationsIn: '@'
                },
                link: function ($scope) {
                    var $thingsToSee = document.getElementsByClassName('tts-container');
                    var $destinationsIn = document.getElementsByClassName('destinations-in');

                    $scope.mainLinks = [
                        {
                            name: 'Overview',
                            url: $scope.overview,
                            show: true,
                            active: (/-holidays$/).test($window.location.pathname)
                        }, {
                            name: 'Destinations in',
                            url: $scope.destinationsIn ? $scope.destinationsIn : $destinationsIn ? '#destinations-in' : '',
                            show: ($scope.destinationsIn !== undefined ? true : $destinationsIn.length > 0),
                            active: !!~$window.location.pathname.indexOf('destinations-in')
                        }, {
                            name: 'Things to see',
                            url: $scope.thingsToSee ? $scope.thingsToSee : $thingsToSee ? '#things-to-see' : '',
                            show: ($scope.thingsToSee !== undefined ? true : $thingsToSee.length > 0),
                            active: !!~$window.location.pathname.indexOf('things-to-see')
                        }, {
                            name: 'Hotels',
                            url: $scope.hotels,
                            show: $scope.hotels,
                            active: !!~$window.location.pathname.indexOf('-hotels')
                        }, {
                            name: 'Offers',
                            url: $scope.offers,
                            show: $scope.offers,
                            id: 'qa-navbar-offers',
                            active: !!~$window.location.pathname.indexOf('-offers')
                        }, {
                            name: 'Tours',
                            url: $scope.tours,
                            show: $scope.tours,
                            active: !!~$window.location.pathname.indexOf('-tours')
                        }, {
                            name: 'Multi-centres',
                            url: $scope.multicentres,
                            show: $scope.multicentres,
                            active: !!~$window.location.pathname.indexOf('/multi-centre')
                        }
                    ];

                    $scope.pageType = 'Overview';

                    $scope.mainLinks.forEach(function mainLinks(link) {
                        if (link.active) {
                            $scope.pageType = link.name;
                        }
                    });
                },
                templateUrl: 'destination-navbar.html'
            };
        }])

        .directive('holidayTypesNavBar', function() {
            return {
                link: function ($scope, $element, $attrs) {
                    $scope.mainLinks = JSON.parse($attrs.holidayTypes);

                    $scope.pageType = 'Overview';

                    $scope.mainLinks.forEach(function mainLinks(link) {
                        if (link.active) {
                            $scope.pageType = link.name;
                        }
                    });

                    angular.element(document).ready(function() {
                        window.dispatchEvent(new CustomEvent('initialise-fixed-tabs'));
                    });
                },
                templateUrl: 'destination-navbar.html'
            };
        });
} ());

;(function(){

'use strict';

angular.module('vhols-destination-navbar').run(['$templateCache', function($templateCache) {

  $templateCache.put('destination-navbar.html', '<div class="navbar-container">\n    <div class="container">\n        <nav class="fixed-tabs" aria-label="Destinations navigation bar">\n            <ul class="fixed-tabs-list">\n                <li ng-repeat="link in mainLinks" class="fixed-tabs-list-item" data-tab-index="{{$index}}">\n                    <a ng-if="link.active" ng-href="{{link.url}}" class="active" aria-current="page">{{link.name}}</a>\n                    <a ng-if="!link.active" ng-href="{{link.url}}">{{link.name}}</a>\n                </li>\n                <li class="fixed-tabs-more" tabindex="0">\n                    <a href="javascript:void(0)" class="fixed-tabs-sub-menu-button" tabindex="-1">\n                        More\n                        <svg width="10px" height="10px" role="presentation">\n                            <use xlink:href="/.resources/virginholidays-web-vhols/versioned/pattern-library/sprites/icons.svg#solid-arrow-down"></use>\n                        </svg>\n                    </a>\n                    <ul class="fixed-tabs-sub-menu">\n                        <li ng-repeat="link in mainLinks" class="fixed-tabs-sub-item tab-gone" data-tab-index="{{$index}}">\n                            <a ng-if="link.active" ng-href="{{link.url}}" class="active" aria-current="page">{{link.name}}</a>\n                            <a ng-if="!link.active" ng-href="{{link.url}}">{{link.name}}</a>\n                        </li>\n                    </ul>\n                </li>\n            </ul>\n        </nav>\n    </div>\n</div>\n');

}]);

})();